import parse, {
  domToReact,
  Element,
  HTMLReactParserOptions,
} from "html-react-parser";
import DOMPurify from "isomorphic-dompurify";
import type { ReactNode } from "react";

/**
 * Default parse options
 */
const defaultParseOptions: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (domNode instanceof Element) {
      const { attribs, children } = domNode;

      if (!attribs) return;

      // Ví dụ custom xử lý
      // if (attribs.dir === "ltr") {
      //   return <div>{domToReact(children)}</div>;
      // }
    }

    return undefined;
  },
};

interface SanitizeDOMDataOptions extends HTMLReactParserOptions {}

/**
 * Sanitize + parse HTML string to ReactNode
 */
export default function sanitizeDOMData(
  htmlString: string,
  options: SanitizeDOMDataOptions = {}
): ReactNode {
  const cleanString = DOMPurify.sanitize(htmlString, {
    USE_PROFILES: { html: true },
  });

  return parse(cleanString, {
    ...defaultParseOptions,
    ...options,
    trim: true,
  });
}
